import React, { ReactElement, SVGProps } from 'react';

export const SvgTwitter = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg fill="none" height={45} width={45} {...props}>
      <circle fill="#25C5B0" r={22.5} cy={22.5} cx={22.5} />
      <path
        d="M31.686 16.275a7.36 7.36 0 01-2.12.58 3.706 3.706 0 001.622-2.042 7.442 7.442 0 01-2.344.896 3.693 3.693 0 00-6.293 3.366 10.468 10.468 0 01-7.61-3.858 3.664 3.664 0 00-.502 1.857c0 1.28.65 2.412 1.644 3.074a3.672 3.672 0 01-1.673-.463v.047a3.691 3.691 0 002.962 3.62 3.677 3.677 0 01-1.667.065 3.7 3.7 0 003.448 2.567 7.406 7.406 0 01-5.467 1.526 10.443 10.443 0 005.66 1.661c6.794 0 10.51-5.628 10.51-10.509 0-.158-.007-.319-.013-.477a7.564 7.564 0 001.843-1.91z"
        fill="#fff"
      />
    </svg>
  );
};
